module.exports = __webpack_public_path__ + "img/214.0d4fe7a7.jpg";